import { Input } from "./input";
import { cn } from "./utils";

export function ModerationInput({
  editing = false,
  className,
  ...props
}) {
  return (
    <Input
      {...props}
      readOnly={!editing}
      tabIndex={editing ? 0 : -1}
      className={cn(
        // базовые стили
        "transition-all",

        // режим ПРОСМОТРА (как текст)
        !editing && [
          "border-none",
          "bg-transparent",
          "shadow-none",
          "px-0",
          "py-0",
          "h-auto",
          "focus-visible:ring-0",
          "focus-visible:border-transparent",
          "pointer-events-none",
          "text-foreground"
        ],

        // режим РЕДАКТИРОВАНИЯ (обычный input)
        editing && [
          "pointer-events-auto"
        ],

        className
      )}
    />
  );
}
